import { getMerchantExportLink } from './export-link';
import { getMerchantCommissions } from './merchant-index';
import { getMerchantSummary } from './merchant-summary';

export const MerchantCommissionsAPI = {
  getMerchantCommissions,
  getMerchantSummary,
  getMerchantExportLink,
};
